import React from 'react';
import { Tag } from 'components/Tag';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';

export default function PlBadgeTags({ offerMetadata, datatestid }) {
  const showBadges =
    offerMetadata.badgeLabel ||
    offerMetadata.partnerTag ||
    offerMetadata.secure;

  return (
    <>
      {showBadges && (
        <FlexContainer
          datatestid={datatestid}
          className="flex-rowWrap margB8 m-margB24"
        >
          {offerMetadata.badgeLabel && (
            <Tag
              datatestid={`${datatestid}-badge`}
              backgroundClass="bgYellow075"
              extClass="borderRad12 letterSpacing06 margB8 margR8"
            >
              {offerMetadata.badgeLabel}
            </Tag>
          )}
          {offerMetadata.partnerTag && (
            <Tag
              datatestid={`${datatestid}-partner`}
              backgroundClass="bgGray025"
              extClass="borderRad12 letterSpacing06 margB8"
            >
              {offerMetadata.partnerTag}
            </Tag>
          )}
        </FlexContainer>
      )}
    </>
  );
}
